import { ProductNoticeModel } from 'app/model/products/product-notice.model';
import { ProductReviewModel } from 'app/model/products/product-review.model';

export class ProductListModel {
    address: string;
    allotment: number;
    countrySlug: string;
    countryTitle: string;
    currencyCode: string;
    currencyId: number;
    destinationSlug: string;
    destinationTitle: string;
    image: string;
    latitude: number;
    longitude: number;
    netPrice: number;
    notices: ProductNoticeModel;
    payOn: string;
    lastDayCancel: string;
    pointPriority: number;
    productCategorySlug: string;
    productId: number;
    productTitle: string;
    rating: number;
    ratingUser: number;
    recommend: boolean;
    reviewCount: number;
    reviewRating: ProductReviewModel;
    slug: string;
    totalPrice: number;
    distance: number;
    overPrice: number;


    constructor(productItem: any = undefined) {
        if (productItem) {
            this.address = productItem.address;
            this.allotment = productItem.allotment;
            this.countrySlug = productItem.countrySlug;
            this.countryTitle = productItem.countryTitle;
            this.currencyCode = productItem.currencyCode;
            this.currencyId = productItem.currencyId;
            this.destinationSlug = productItem.destinationSlug;
            this.destinationTitle = productItem.destinationTitle;
            this.image = productItem.image;
            this.latitude = productItem.latitude;
            this.longitude = productItem.longitude;
            this.netPrice = productItem.netPrice;
            this.notices = productItem.notices;
            this.payOn = productItem.payOn;
            this.lastDayCancel = productItem.lastDayCancel;
            this.pointPriority = productItem.pointPriority;
            this.productCategorySlug = productItem.productCategorySlug;
            this.productId = productItem.productId;
            this.productTitle = productItem.productTitle;
            this.rating = productItem.rating;
            this.ratingUser = productItem.ratingUser;
            this.recommend = productItem.recommend;
            this.reviewCount = productItem.reviewCount;
            this.reviewRating = productItem.reviewRating;
            this.slug = productItem.slug;
            this.totalPrice = productItem.totalPrice;
            this.distance = productItem.distance;
            this.overPrice = productItem.overPrice
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/model/products/product-list.model.ts